import React, { FC } from 'react';
import { ProductLineItemType } from '../../../models/product-line-item-type';
import { BasketTableLabelsType } from '../../../models/basket-table-labels-type';
import Modal from '../modal/modal';
// eslint-disable-next-line import/no-cycle
import BasketTable from '../basket-table/basket-table';
import { CheckoutBasketTableLabelsType } from '../../../models/checkout-basket-table-labels-type';

interface Props {
  lineItems?: ProductLineItemType[];
  labels: BasketTableLabelsType;
  checkoutLabels: CheckoutBasketTableLabelsType;
  onLineAdd: (item: ProductLineItemType, quantity: number) => void;
  onLineReplace: (item: ProductLineItemType, quantity: number) => void;
}

const BasketRecommendedAlternatives: FC<Props> = ({
  lineItems,
  labels,
  checkoutLabels,
  onLineAdd,
  onLineReplace,
}) => {
  return (
    <Modal>
      <div className="flex flex-col space-y-4">
        <h4 className="page-heading-four">
          {checkoutLabels.recommendedAlternativesPopupHeading}
        </h4>
        <BasketTable
          labels={labels}
          checkoutLabels={checkoutLabels}
          lineItems={lineItems}
          onLineUpdateQuantity={() => true}
          onLineAdd={(item, quantity) => onLineAdd(item, quantity)}
          onLineReplace={(item, quantity) => onLineReplace(item, quantity)}
          features={{
            addButton: true,
            checkoutLayout: false,
            discountColumn: false,
            favouritesLayout: false,
            inStockColumn: false,
            productWarnings: true,
            quantityBreaksSave: false,
            quantityReadonly: false,
            recommendedAlternatives: false,
            removeButton: false,
            replaceButton: true,
            subtotalColumn: false,
            updateQuantityButton: false,
          }}
        />
      </div>
    </Modal>
  );
};

BasketRecommendedAlternatives.defaultProps = {
  lineItems: null,
};

export default BasketRecommendedAlternatives;
